import React from 'react';

const PhoneIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      height="0"
      viewBox="0 0 82 81"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="#fff"
        d="M13.664 0L1.777 10.809.06 25.625l15.027 28.04 35.89 25.983L63.368 81l11.696-6.883 6.894-9.004-2.066-5.789-20.66-11.261-4.473 1.968-4.125 8.602-3.785 1.719s-14.446-7.567-15.48-8.254C30.331 51.41 18.98 37.645 18.98 37.645l-.687-6.188 14.45-6.535.687-5.164L19.652.828zm0 0"
      ></path>
    </svg>
  );
};

export default PhoneIcon;
